import React from 'react'
import { Field } from 'redux-form'
import TextAreaField from '../../../../components/Form/TextAreaField'
import { connect } from 'react-redux'
import getFormValidations from './formValidations'
import {translateName} from "../../../../utils/i18n";

// binding for redux-form
const Input = ({ input, meta:{touched, error}, path, required, placeholder, editable, disabled, dynamicHeight, t, language, style, readOnly, userGroupSelectedColor, groupModel  }) => {
    const translatedError = t(error)
    const rows = dynamicHeight
        ? input.value.split(/\r\n|\r|\n/).length
        : 3

    const colorStyle = userGroupSelectedColor ? {color: groupModel.selectedColor}: {}
    const fieldStyle = style || {}

    return readOnly
        ? <div style={{...fieldStyle, ...colorStyle}}>{translateName(input.value, language)}</div>
        : <TextAreaField {...input} path={path} required={required} touched={touched} rows={rows} error={translatedError} placeholder={placeholder} disabled={!editable || disabled} t={t} style={style} />
}

// the binding function has to be outside to avoid re-rendering
// https://github.com/erikras/redux-form/issues/1094

const FormTextField = ({ field, t, objectMode, language, groupModel }) => {
    const validations = getFormValidations(field, t)
    return (
        <Field
            name={field.path}
            path={field.tKey || field.path}
            required={field.required}
            component={Input}
            validate={validations}
            placeholder={field.placeholder}
            editable={!field.editable ? objectMode === 'newObject' : field.editable  }
            disabled={field.disabled || !field.writable}
            readOnly={field.readOnly}
            style={field.style}
            dynamicHeight={field.dynamicHeight}
            userGroupSelectedColor={field.userGroupSelectedColor}
            t={t}
            language={language}
            groupModel={groupModel}
        />
    )
}

const mapStateToProps = () => ({})

export default connect(mapStateToProps)(FormTextField)
